import React, { useEffect } from 'react'
import "../pages/OrgAdmin/style.css"
import "../../src/pages/campaign/style.css"
import CustomBackButton from '../components/BackButton';
import { FaUserEdit } from "react-icons/fa";
import { Skeleton } from "@mui/material"
import { getLocalStorage } from '../utils/localStorage';
import { getOrgAdminDetails } from '../service/api';
import { convertTimestamptoDate } from '../utils/helper';
import { useNavigate } from 'react-router-dom';
import {
    FiInfo, FiCalendar, FiClock, FiCheckCircle, FiXCircle, FiUserCheck, FiActivity, FiUser,
    FiLayers, FiTag, FiGlobe, FiBox, FiMail, FiLink, FiHash, FiFileText
} from "react-icons/fi";
import {
    FaDatabase, FaRegListAlt, FaEnvelopeOpenText
} from "react-icons/fa";
import {
    MdOutlineCategory, MdOutlineDescription
} from "react-icons/md";

const Section = ({ heading, data, loading }) => {
      const handleCopy = (e) => {
        const text = e.target.innerText; // get text from <p>
        navigator.clipboard.writeText(text)
    };
    return (
        // <div
        //     className="section"
        //     style={{
        //         border: "1px solid #e4dddd",
        //         borderRadius: "0px 0px 10px 10px",
        //     }}
        // >
        //     <h2 className="section-heading" style={{ background: "rgb(210 210 210 / 37%)", color: "black" }}>
        //         {heading}
        //     </h2>
        //     <div className="section-content" style={{ padding: 5, background: "#f6f5f5" }}>

        //         <div className="ctsb-box-1">
        //             {!loading ? (
        //                 <>
        //                     {data.map((item) => {
        //                         return (
        //                             <div key={item.key} className="ctsb-box-item-1">
        //                                 <span>{item.label}</span>
        //                                 <hr style={{ margin: "2px 0px" }}></hr>
        //                                 <p style={{ fontSize: "12px" }}>{item.value ? item.value : "-"}</p>
        //                             </div>
        //                         )
        //                     })}
        //                 </>
        //             ) : (
        //                 <>
        //                     {[...Array(5)].map((_, key) => {
        //                         return (
        //                             <div key={key} className="ctsb-box-item-1">
        //                                 <span className="item-label-cards" style={{ width: 100 }}>
        //                                     <Skeleton />
        //                                 </span>
        //                                 <hr style={{ margin: "2px 0px" }}></hr>
        //                                 <p className="item-label-cards" style={{ fontSize: ".9em", width: 75 }}>
        //                                     <Skeleton />
        //                                 </p>
        //                             </div>
        //                         )
        //                     })}
        //                 </>
        //             )}
        //         </div>

        //     </div>
        // </div>
        <>
            <div className="campaign-section">
                    <h2 className="campaign-section-heading">{heading}</h2>
                    <div className="campaign-section-content">
                        <div className="campaign-items-container">
                            {!loading ? (
                                data.map((item, index) => (
                                    <div key={item.key || index}
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start",
                                            gap: 5
                                        }}
                                        className="campaign-item">
                                        <item.icon
                                            style={{
                                                margin: "8px 10px 10px 0px",
                                                color: "#605f64",
                                                width: 15,
                                                height: 15
                                            }} />
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start",
                                            gap: 5,
                                            flexDirection: "column"
                                        }}>
                                            <span className="campaign-item-label">{item.label}</span>
                                            {/* <hr className="campaign-item-separator" /> */}
                                            {
                                                item.label === "Link" ?
                                                    <p className="campaign-item-value"
                                                        style={{
                                                            color: "#647AD1",
                                                            width: 180,
                                                           
                                                        }}
                                                        onClick={handleCopy}
                                                    >{item.value}</p> :
                                                    <p
                                                        // style={{
                                                        //     whiteSpace: "nowrap"
                                                        // }}
                                                        className="campaign-item-value"
                                                        onClick={handleCopy}
                                                    >{item.value}</p>
                                            }
        
                                        </div>
                                    </div>
                                ))
                            ) : (
                                [...Array(5)].map((_, index) => (
                                    <div key={index} className="campaign-item">
                                        <span className="campaign-item-label">
                                            <Skeleton width={90} height={10} />
                                        </span>
                                        <hr className="campaign-item-separator" />
                                        <p className="campaign-item-value">
                                            <Skeleton width={70} height={10} />
                                        </p>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
        </>
    )
}
// const currentUser = getLocalStorage("CURRENT_USER");

function MyOrganization() {
    const [authUserDetails, setAuthUserDetails] = React.useState({});
    const currentUser = getLocalStorage("CURRENT_USER");
    const {
        name,
        email,
        phone,
        orgId,
        processName,
        department,
        designation,
        role,
        active,
    } = currentUser
    const {
        id,
        createdDate,
        lastUpdated,
        mobile,
        // email,
        orgName,
        about,
        address,
        gstIn,
        teamSize,
        numberOfProcesses,
        processes,
        whitelistedEmailDomains,
        users,
        usersCap,
        managers,
        managersCap,
        teamLeaders,
        teamLeadersCap,
        teleCallers,
        teleCallersCap,
        isCampaignEnabled,
        campaignCreditsCap,
        campaignCreditsUtilized,
        campaignBudgetCap,
        campaignBudgetUtilized,
        orgStatus,
        isOrgActive,
    } = authUserDetails

    const createDetailBlocks = () => {
        if (!currentUser) return []

        const blocks = [
            {
                key: "cd-basic-detail-org",
                title: "Basic Detail Of Organization",
                value: [
                    { key: "id", label: "Id", value: id ?? "-", icon: FiHash },
                    { key: "created-date", label: "CREATED DATE", value: convertTimestamptoDate(createdDate) ?? "-", icon: FiCalendar },
                    { key: "last-updated", label: "LAST UPDATED", value: convertTimestamptoDate(lastUpdated) ?? "-", icon: FiClock },
                    { key: "mobile", label: "Mobile", value: mobile ?? "-", icon: FiInfo },
                    { key: "email", label: "Email", value: email ?? "-", icon: FiMail },
                    { key: "orgName", label: "ORG Name", value: orgName ?? "-", icon: FiLayers },
                    { key: "orgId", label: "ORG Id", value: orgId ?? "-", icon: FiTag },
                    { key: "gstIn", label: "GSTIN", value: gstIn ? gstIn : ("NA" ?? "-"), icon: FiFileText },
                    { key: "isOrgActive", label: "Is Org Active", value: isOrgActive === true ? "Yes" : ("No" ?? "-"), icon: FiCheckCircle },
                    {
                        key: "processes",
                        label: "Processes",
                        value: Array.isArray(processes) ? processes.join(", ") : (processes ?? "-"),
                        icon: MdOutlineCategory
                    },
                    {
                        key: "whitelistedEmailDomains",
                        label: "Whitelisted Email Domains",
                        value: Array.isArray(whitelistedEmailDomains)
                            ? whitelistedEmailDomains.join(", ")
                            : (whitelistedEmailDomains ?? "-"),
                        icon: FiGlobe
                    },
                    { key: "about", label: "About", value: about ?? "-", icon: MdOutlineDescription },
                    { key: "address", label: "Address", value: address ?? "-", icon: FiInfo },
                ],
            },
            {
                key: "cd-team-detail",
                title: "Team Information",
                value: [
                    { key: "teamSize", label: "Team Size", value: teamSize ?? "-", icon: FiUser },
                    { key: "numberOfProcesses", label: "Number Of Processes", value: numberOfProcesses ?? "-", icon: FaRegListAlt },
                    { key: "users", label: "Users", value: users ?? "-", icon: FiUser },
                    { key: "usersCap", label: "Users Cap", value: usersCap ?? "-", icon: FiUserCheck },
                    { key: "managers", label: "Managers", value: managers ?? "-", icon: FiUser },
                    { key: "managersCap", label: "Managers Cap", value: managersCap ?? "-", icon: FiUserCheck },
                    { key: "teamLeaders", label: "Team Leaders", value: teamLeaders ?? "-", icon: FiUser },
                    { key: "teamLeadersCap", label: "Team Leaders Cap", value: teamLeadersCap ?? "-", icon: FiUserCheck },
                    { key: "teleCallers", label: "TeleCallers", value: teleCallers ?? "-", icon: FiUser },
                    { key: "teleCallersCap", label: "TeleCallers Cap", value: teleCallersCap ?? "-", icon: FiUserCheck },
                ],
            },
            {
                key: "cd-campaign-detail",
                title: "Campaign Information",
                value: [
                    {
                        key: "isCampaignEnabled",
                        label: "Is Campaign Enabled",
                        value: isCampaignEnabled === true ? "Yes" : ("NO" ?? "-"),
                        icon: FiCheckCircle
                    },
                    { key: "campaignCreditsCap", label: "Campaign Credits Cap", value: campaignCreditsCap ?? "-", icon: FaDatabase },
                    { key: "campaignCreditsUtilized", label: "Campaign Credits Utilized", value: campaignCreditsUtilized ?? "-", icon: FiActivity },
                    { key: "campaignBudgetCap", label: "Campaign Budget Cap", value: campaignBudgetCap ?? "-", icon: FaDatabase },
                    { key: "campaignBudgetUtilized", label: "Campaign Budget Utilized", value: campaignBudgetUtilized ?? "-", icon: FiActivity },
                ],
            }

        ];
        return blocks


    }


    useEffect(() => {
        if (role[0] === "ROLE_ADMIN") {
            getOrgAdminDetails({}, (res) => {
                if (res && res.success) {
                    setAuthUserDetails(res?.response)

                    //   setState(prevState => ({
                    //     ...prevState,
                    //     company: res?.response?.orgName || "",
                    //   }))


                } else {
                }

            })
        }

    }, [])
    const navigate = useNavigate();

    const handleEditUser = () => {
        navigate("/home/myProfile/Edituser", { state: { authUserDetails: authUserDetails } });


    }

    return (
        <>
            <div className="my-profile-container">
                <div className='ca-main-screen-head'>
                    <div>My organization / </div>  <div className="titile-of-organaztion-details-page" style={{color:"black", marginTop:"5px"}}> View your organization details here.</div>
                </div>
                {/* <div className="heading-top-div-1">
                    <span className="heading-top-span-title">
                        My organization /
                        <p className="titile-of-organaztion-details-page">
                            View your organization details here.
                        </p>
                    </span>
                </div> */}
                <div style={{padding:"0 20px", display: "flex", flexDirection: "column", gap: "10px"}}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ marginTop: 10, padding: 0, overflow: "hidden", fontFamily: "gb Regular" }}>
                            <CustomBackButton />
                        </div>
                        {role[0] === "ROLE_ADMIN" ? (<>
                            <div className="manage-organization">
                                <button className="manage-org-button-2"
                                    onClick={handleEditUser}
                                >
                                    <div className="org-edit-button-div">
                                        Edit <FaUserEdit />
                                    </div>

                                </button>
                            </div>
                        </>) : (<></>)}
                    </div>
                    <div className="ResponseInfoDetailBox-111" style={{background:"rgb(244, 249, 253)"}}>
                        {createDetailBlocks().map((item) => (
                            <Section key={item.key} heading={item.title} data={item.value} />
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyOrganization;